import { useState, type FormEvent } from 'react'
import { guestApi, type GuestRoomInfo } from '@/api/meet-api'
import { beginLogin, setGuestSession } from '@/auth/session'
import { config } from '@/config'

const rememberedName = () => {
  try {
    return localStorage.getItem(config.storageKeys.name) ?? ''
  } catch {
    return ''
  }
}

/**
 * Người chưa đăng nhập mở đường dẫn của cuộc họp đang nhận khách ngoài: nhập tên (và đơn vị) để
 * xin vào, hoặc đăng nhập AloUbot nếu có tài khoản. Khách ngoài luôn chờ chủ phòng duyệt.
 */
export function GuestEntry({ room, onEntered }: { room: GuestRoomInfo; onEntered: () => void }) {
  const [name, setName] = useState(rememberedName)
  const [note, setNote] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const submit = async (event: FormEvent) => {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      const issued = await guestApi.enter(room.code, name.trim(), note.trim())
      try {
        localStorage.setItem(config.storageKeys.name, issued.name)
      } catch {
        // không nhớ được tên: lần sau nhập lại
      }
      setGuestSession({
        code: room.code,
        token: issued.token,
        expiresAt: Date.parse(issued.expires_at),
        orgId: '',
        userId: issued.user_id,
        name: issued.name,
        avatar: null,
      })
      onEntered()
    } catch (e) {
      setError((e as Error).message)
      setBusy(false)
    }
  }

  return (
    <div className="mu-center mu-guest">
      <form className="mu-guest__card" onSubmit={(e) => void submit(e)}>
        <div className="mu-brand">
          <i className="bi bi-camera-video-fill" /> MeetUbot
        </div>
        <h1>{room.title || 'Cuộc họp'}</h1>
        <p className="mu-muted">
          Do {room.created_by_name} tổ chức · mã {room.code}
        </p>
        <label className="mu-field">
          <span>Tên của bạn</span>
          <input value={name} onChange={(e) => setName(e.target.value)} maxLength={60} autoComplete="name" required autoFocus />
        </label>
        <label className="mu-field">
          <span>Đơn vị / lý do tham gia (không bắt buộc)</span>
          <input value={note} onChange={(e) => setNote(e.target.value)} maxLength={160} placeholder="Ví dụ: Công ty Xây dựng A, tư vấn giám sát" />
        </label>
        {error && <p className="mu-error">{error}</p>}
        <button className="mu-btn mu-btn--primary mu-btn--lg" disabled={busy || !name.trim()}>
          <i className="bi bi-door-open" /> Xin vào cuộc họp
        </button>
        <p className="mu-muted mu-small">Chủ phòng sẽ xem tên và cho bạn vào. Bạn không cần tài khoản.</p>
        <button type="button" className="mu-btn mu-btn--ghost" onClick={() => void beginLogin()}>
          Có tài khoản AloUbot? Đăng nhập
        </button>
      </form>
    </div>
  )
}
